// @flow
import * as Immutable from 'immutable';
import ImmutableModel from './ImmutableModel';

export type TransactionChecklistValueTypeEnum =
    | 'BOOLEAN'
    | 'SINGLE_CHOICE'
    | 'TEXT_FIELD'
    | 'PIN'
    | 'SIGNATURE'
    | 'PHOTO'
    | 'RATING'
    | 'URL';

export type TransactionChecklistValueModelType = {
    id: string,
    name: string,
    selectedValue: string,
    selectedValues: ?Array<string>,
    type: TransactionChecklistValueTypeEnum
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class TransactionChecklistValue extends ImmutableModel {
    static fromJS(
        json: TransactionChecklistValueModelType
    ): TransactionChecklistValue {
        const state: Object = Object.assign({}, json);
        state.selectedValues = state.selectedValues
            ? Immutable.List(state.selectedValues)
            : state.selectedValues;
        return new this(Immutable.Map(state));
    }

    toJS(): TransactionChecklistValueModelType {
        return {
            id: this.id,
            name: this.name,
            selectedValue: this.selectedValue,
            selectedValues: this.selectedValues
                ? this.selectedValues.toArray()
                : this.selectedValues,
            type: this.type
        };
    }

    get id(): string {
        return this._state.get('id');
    }

    setId(id: string): this {
        return this.clone(this._state.set('id', id));
    }

    get name(): string {
        return this._state.get('name');
    }

    setName(name: string): this {
        return this.clone(this._state.set('name', name));
    }

    get selectedValue(): string {
        return this._state.get('selectedValue');
    }

    setSelectedValue(selectedValue: string): this {
        return this.clone(this._state.set('selectedValue', selectedValue));
    }

    get selectedValues(): ?Immutable.List<string> {
        return this._state.get('selectedValues');
    }

    setSelectedValues(selectedValues: ?Immutable.List<string>): this {
        return this.clone(this._state.set('selectedValues', selectedValues));
    }

    get type(): TransactionChecklistValueTypeEnum {
        return this._state.get('type');
    }

    setType(type: TransactionChecklistValueTypeEnum): this {
        return this.clone(this._state.set('type', type));
    }
}
